import { Modal } from 'app/components/ui/Modal'
import React from 'react'

import { SponsorRequestContractSignForm } from './SponsorRequestContractSignForm'

type Props = {
  sponsorRequestId: number
  sponsorRequestOutcomeDocument: string
  onCancel: () => void
  onConfirm: () => void
}
export const SponsorRequestSignModal = ({
  sponsorRequestId,
  sponsorRequestOutcomeDocument,
  onCancel,
  onConfirm,
}: WithChildren<Props>): JSX.Element => {
  return (
    <Modal
      onCloseRequest={() => onCancel()}
      hasOuterScroll
      title={`Conferma l'operazione`}
    >
      <SponsorRequestContractSignForm
        sponsorRequestId={sponsorRequestId}
        sponsorRequestOutcomeDocument={sponsorRequestOutcomeDocument}
        onSuccess={onConfirm}
        onCancel={onCancel}
      />
    </Modal>
  )
}
